import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef,MatDialog} from "@angular/material";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// import { , MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatPaginator } from '@angular/material';
import { ClipBoardService } from '../../../services/clipboard.service'
import { ServerService } from '../../../services/server.service';
import { ClientRuleEntryModalComponent } from '../client-rule-entry-modal/client-rule-entry-modal.component';
import { DatePipe } from '@angular/common';
@Component({
    selector: 'client-rule-assignment-create-modal',
    templateUrl: './client-rule-assignment-create-modal.component.html',
    encapsulation:ViewEncapsulation.None,
    styleUrls: ['./client-rule-assignment-create-modal.component.scss']
})
export class ClientRuleAssignmentCreateModalComponent implements OnInit {
    public currentUser = JSON.parse(localStorage.getItem("userInfo"));
    project: any = JSON.parse(localStorage.getItem("projectInfo"))
    action = "";
    btnStatus: boolean = false
    createRuleForm: FormGroup;
    projects: any[] = []
    filteredProjects: any[] = []
    authToken = localStorage.getItem("token")
    searchProject = '';

    clientRuleEntryModalComponent: MatDialogRef<ClientRuleEntryModalComponent>
    constructor(
        private serverService: ServerService,
        private clipBoardService: ClipBoardService,
        private fb: FormBuilder,
        private dialog: MatDialog,
        private datePipe: DatePipe,
        @Inject(MAT_DIALOG_DATA) public data,
        private dialogRef: MatDialogRef<ClientRuleAssignmentCreateModalComponent>) {
        this.createRuleForm = this.fb.group({
            name: ['', Validators.required],
            project: ['', Validators.required],
            createdDate:[this.datePipe.transform(new Date(), 'dd/MM/yyyy')],
            createdTime:[this.datePipe.transform(new Date(), 'hh:mm a')],
            // createdTime:[Date,'hh:mm a'],
            // <small>{{rule.created_at | date : 'dd/MM/yyyy'}}, {{rule.created_at | date : 'hh:mm a'}}</small>
            searchProject: ['']
        })
        this.getProject()
    }

    ngOnInit() {

    }

    getProject() {
        this.serverService.projectsList(this.authToken).subscribe(
            data => {
                this.projects = data
                this.filteredProjects = data
            },
            err => {
                this.clipBoardService.checkServerError(err, this.authToken)
            }
        )
    }

    close() {
        this.dialogRef.close();
    }

    save(event:any) {
        // console.log(event)
        //this.btnStatus = true
        this.btnStatus = false
        let formValue = this.createRuleForm.value;
        formValue.add = true;
        formValue.id = this.data
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        formValue.userName = userInfo['name'];
        //  console.log(formValue)
        this.clientRuleEntryModalComponent = this.dialog.open(ClientRuleEntryModalComponent, {
            hasBackdrop: true,
            disableClose: false,
            autoFocus: true,
            width: '50%',
            // width: '100%',
            // maxWidth: '100vw',
            panelClass: 'cdk-overlay-panel-right-side',
             data: formValue
          });
          this.clientRuleEntryModalComponent.afterClosed().subscribe(result => {
            //console.log('2nd level')
            if (result != undefined) {
            //   this.showComponentLoader = true
              this.ngOnInit()
            }
          })
        // let body = {
        //     "rule_name": this.createRuleForm.value.name,
        //     "project_id": this.createRuleForm.value.project
        // }
        // this.serverService.createAssignment(body, this.authToken).subscribe(
        //     data => {
        //         this.btnStatus = false
        //         this.clipBoardService.showMessgeInText("Rule Assignment Created Successfully", "success-snackbar")
        //         this.dialogRef.close("Rule Assignment Created Successfully")
        //     },
        //     err => {
        //         this.btnStatus = false
        //         this.clipBoardService.checkServerError(err, this.authToken)
        //     }
        // )
    }

    onKeyProject(val) {
        let body = {
            'module_type':'projects',
            'search':this.searchProject
        }
        if(val.keyCode == 32){
            this.searchProject += ' ';
        }
        this.serverService.getProjectBySearch(body,this.authToken).subscribe((data)=>{
            this.filteredProjects = data.projects;
        })
        // let filter = val.toLowerCase();
        // this.filteredProjects = this.projects.filter(option => option.name.toLowerCase().includes(filter));
    }

    onFocusOutEvent(event) {
        this.createRuleForm.controls.searchProject.setValue('')
        this.onKeyProject('')
    }
}

